(() => {
  if (window.TuzexLiveBrands) return;
  const snapshots = new Map();
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function combine(rows, excluded = []) {
    const denied = new Set(excluded.map(normalize));
    const grouped = new Map();
    rows.forEach(row => {
      const key = normalize(row.name);
      if (!key || denied.has(key) || !Number.isInteger(row.count) || row.count <= 0) return;
      if (!grouped.has(key)) grouped.set(key, {key, name: row.name, count: 0, values: []});
      const group = grouped.get(key);
      if (group.values.includes(row.value)) return;
      group.count += row.count;
      group.values.push(row.value);
    });
    return [...grouped.values()].sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'sk'));
  }
  function destination(source, values) {
    const url = new URL(source, location.origin);
    url.search = '';
    values.forEach(value => url.searchParams.append('filter.p.vendor', value));
    return url.pathname + url.search;
  }
  async function read(source, page) {
    const url = new URL(source, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid source');
    url.search = '';
    url.searchParams.set('section_id', 'tx-brand-feed');
    url.searchParams.set('page', String(page));
    url.searchParams.set('sort_by', 'title-ascending');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Brand data unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = JSON.parse(doc.querySelector('[data-tx-brand-data]')?.textContent || 'null');
    if (!data || data.version !== 1 || data.collection !== decodeURIComponent(url.pathname.split('/').filter(Boolean).pop())) throw new Error('Invalid brand data');
    return data;
  }
  async function fetchRows(source) {
    const first = await read(source, 1);
    if (first.mode === 'facets') {
      if (!Array.isArray(first.brands) || first.brands.some(b => typeof b.name !== 'string' || typeof b.value !== 'string' || !Number.isInteger(b.count) || b.count < 0) || first.brands.reduce((total, b) => total + b.count, 0) !== first.total) throw new Error('Incomplete brand totals');
      return first.brands;
    }
    if(first.mode==='products' && first.total===0 && Array.isArray(first.products) && first.products.length===0)return [];
    if (first.mode !== 'products' || first.page !== 1 || !Number.isInteger(first.pages) || first.pages < 1 || first.pages > 100 || first.total > 25000) throw new Error('Incomplete collection');
    const pages = [first];
    for (let page = 2; page <= first.pages; page += 3) {
      const numbers = Array.from({length: Math.min(3, first.pages - page + 1)}, (_, i) => page + i);
      const next = await Promise.all(numbers.map(number => read(source, number)));
      next.forEach((data, i) => {
        if (data.mode !== 'products' || data.page !== numbers[i] || data.pages !== first.pages || data.total !== first.total) throw new Error('Collection changed during read');
      });
      pages.push(...next);
    }
    const products = new Map();
    pages.forEach(page => {
      if (!Array.isArray(page.products)) throw new Error('Invalid products');
      page.products.forEach(product => {
        if (!product.id || typeof product.vendor !== 'string' || typeof product.available !== 'boolean') throw new Error('Invalid product');
        products.set(product.id, product);
      });
    });
    if (products.size !== first.total) throw new Error('Incomplete products');
    const counts = new Map();
    products.forEach(product => {
      if (product.available && product.vendor.trim()) counts.set(product.vendor, (counts.get(product.vendor) || 0) + 1);
    });
    return [...counts].map(([name, count]) => ({name, value: name, count}));
  }
  function peek(source) {
    try { const data=JSON.parse(localStorage.getItem('tx-brands-v13:'+new URL(source,location.origin).pathname)||'null');return data && Array.isArray(data.rows) && Date.now()-data.time<86400000 ? data : null; } catch {return null;}
  }
  function seed(source,rows,time=Date.now()) {const key=new URL(source,location.origin).pathname;if(Array.isArray(rows))snapshots.set(key,{rows,time});}
  async function load(source) {
    const key = new URL(source, location.origin).pathname;
    const existing = snapshots.get(key);
    if (existing?.promise) return existing.promise;
    if (existing?.rows && Date.now() - existing.time < 60000) return existing.rows;
    const state = existing || {};
    state.promise = fetchRows(source).then(rows => {
      state.rows = rows; state.time = Date.now(); try{localStorage.setItem('tx-brands-v13:'+key,JSON.stringify({rows,time:state.time}));}catch{} return rows;
    }).finally(() => { state.promise = null; });
    snapshots.set(key, state);
    return state.promise;
  }
  window.TuzexLiveBrands = {normalize, combine, destination, load, peek, seed};
})();
